module.exports = __webpack_public_path__ + "static/img/center_img5.de8cc543.png";